module.exports = __webpack_public_path__ + "img/partner_bg.5a938d54.jpg";